var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.type === 'available_countries' && _vm.isAllCountriesSelected(_vm.list))?[_vm._v("\n    All\n  ")]:(_vm.notEmptyList)?_vm._l((_vm.list),function(item,i){return _c('el-tag',{key:i},[_vm._v(_vm._s(item))])}):[_vm._v("/")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }